import { render, staticRenderFns } from "./SocialMediaModal.vue?vue&type=template&id=1f33ba94"
import script from "./SocialMediaModal.vue?vue&type=script&lang=js"
export * from "./SocialMediaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports